<bw-section-card-legacy [header]="'LOAN_MENU_DISCLAIMER_SECTION_HEADER' | translate">
  <ng-template #wrappedContent>
    <typography-legacy text-medim-regular color="var(--secondary-text)" class="pt-sm pb-sm">
      {{ 'LOAN_DISCLAIMER_DESC' | translate }}
    </typography-legacy>
  </ng-template>
</bw-section-card-legacy>
